<script>
import { computed, onBeforeMount, reactive, watch, nextTick, ref } from 'vue';
import router from "@/router";
import { SimpleBar } from "simplebar-vue3";
import { layoutComputed } from "@/state/helpers";
const { useStore } = require("vuex");

import NavBar from "@/components/nav-bar";
import Menu from "@/components/menu.vue";
import RightBar from "@/components/right-bar";
import Footer from "@/components/footer";
localStorage.setItem('hoverd',false);
import LogoLargeLight from '@/assets/images/logo/TS-Logo-2-wh.svg';
import LogoLargeDark from '@/assets/images/logo/TS-Logo-2-bk.svg';
import LogoSmallLight from '@/assets/images/logo/TS-Symbol-wh.svg';
import LogoSmallDark from '@/assets/images/logo/TS-Symbol-bk.svg';

/**
 * Vertical layout
 */
export default {
  components: { NavBar, RightBar, Footer, SimpleBar, Menu },
  setup() {
    const store = useStore();
    const logoKey = ref(Date.now())
    const initInfo = {
      type: 'SAUNA',
      logoLargeLightUrl: LogoLargeLight,
      logoLargeDarkUrl: LogoLargeDark,
      logoSmallLightUrl: LogoSmallLight,
      logoSmallDarkUrl: LogoSmallDark,
    }
    const info = reactive({
      ...initInfo
    });
    const isReloadLogo = computed(() => store.getters['settings/getIsReloadLogo'])

    async function toObjectUrl(url) {
      try {
        const res = await fetch(url, { cache: 'no-store', mode: 'cors' });
        if (!res.ok) throw new Error("fetch failed: " + res.status);
        const blob = await res.blob();
        return URL.createObjectURL(blob);
      } catch (err) {
        console.error("Error loading image blob", err);
        return ""; // fallback
      }
    }

    watch(isReloadLogo, async () => {
      if (isReloadLogo.value) {
        await handleLoadLogo();
        logoKey.value = Date.now();
        store.commit("settings/SET_RELOAD_LOGO", false);
      }
    });

    const handleLoadLogo = async () => {
      const allFacilities = localStorage.getItem("listFacilities");
      const facilities = allFacilities ? JSON.parse(allFacilities) : [];
      const facilityId = store.getters['settings/getFacilityId'];
      const facility = facilities.find(f => f.value === facilityId);
      
      if (facility) {
        info.logoSmallDarkUrl = await toObjectUrl(facility.logoSmallDarkUrl);
        info.logoSmallLightUrl = await toObjectUrl(facility.logoSmallLightUrl);
        info.logoLargeDarkUrl = await toObjectUrl(facility.logoLargeDarkUrl);
        info.logoLargeLightUrl = await toObjectUrl(facility.logoLargeLightUrl);
      } else {
        Object.assign(info, initInfo);
      }
    };

    const facilityId = computed(() => store.getters['settings/getFacilityId']);

    onBeforeMount(() => {
      handleLoadLogo();
    });
    
    watch(facilityId, async (newVal, oldVal) => {
      if (newVal === oldVal) return;

      handleLoadLogo()
    });
    
    return {
      info,
      logoKey
    };
  },
  data() {
    return {
      isMenuCondensed: false,
    };
  },
  computed: {
    ...layoutComputed,
  },
  created: () => {
    document.body.removeAttribute("data-layout", "horizontal");
    document.body.removeAttribute("data-topbar", "dark");
    document.body.removeAttribute("data-layout-size", "boxed");
  },
  methods: {
    initActiveMenu() {
            if (document.documentElement.getAttribute('data-sidebar-size') === 'sm-hover') {
                localStorage.setItem('hoverd',true)
                document.documentElement.setAttribute('data-sidebar-size', 'sm-hover-active');
            } else if (document.documentElement.getAttribute('data-sidebar-size') === 'sm-hover-active') {
                localStorage.setItem('hoverd',false)
                document.documentElement.setAttribute('data-sidebar-size', 'sm-hover');
            } else {
                document.documentElement.setAttribute('data-sidebar-size', 'sm-hover');
            }
    },
    toggleMenu() {
      document.body.classList.toggle("sidebar-enable");

      if (window.screen.width >= 992) {
        // eslint-disable-next-line no-unused-vars
        router.afterEach((routeTo, routeFrom) => {
          document.body.classList.remove("sidebar-enable");
          document.body.classList.remove("vertical-collpsed");
        });
        document.body.classList.toggle("vertical-collpsed");
      } else {
        // eslint-disable-next-line no-unused-vars
        router.afterEach((routeTo, routeFrom) => {
          document.body.classList.remove("sidebar-enable");
        });
        document.body.classList.remove("vertical-collpsed");
      }
      this.isMenuCondensed = !this.isMenuCondensed;
    },
    toggleRightSidebar() {
      document.body.classList.toggle("right-bar-enabled");
    },
    hideRightSidebar() {
      document.body.classList.remove("right-bar-enabled");
    },
  },
  mounted() {
    if(localStorage.getItem('hoverd')=='true'){
       document.documentElement.setAttribute('data-sidebar-size', 'sm-hover-active');
    }
    document.getElementById('overlay').addEventListener('click',()=>{
      document.body.classList.remove('vertical-sidebar-enable')
    })

    console.log(this.info)
  },
};
</script>

<template>
  <div id="layout-wrapper">
    <NavBar />
    <div>
      <!-- ========== Left Sidebar Start ========== -->
      <!-- ========== App Menu ========== -->
      <div class="app-menu navbar-menu">
        <!-- LOGO -->
        <div class="navbar-brand-box">
          <!-- Dark Logo-->
          <router-link to="/" class="logo logo-dark">
            <span class="logo-sm">
              <img
                :key="logoKey + '-small-dark'"
                :src="info.logoSmallDarkUrl"
                alt=""
                height="32"
              />
            </span>
            <span class="logo-lg">
              <img
                :key="logoKey + '-large-dark'"
                :src="info.logoLargeDarkUrl"
                alt=""
                height="38"
              />
            </span>
          </router-link>
          <!-- Light Logo-->
          <router-link to="/" class="logo logo-light">
            <span class="logo-sm">
              <img
                :src="info.logoSmallLightUrl"
                :key="logoKey + '-small-light'"
                alt=""
                height="32"
              />
            </span>
            <span class="logo-lg">
              <img
                :src="info.logoLargeLightUrl"
                :key="logoKey + '-large-light'"
                alt=""
                height="38"
              />
            </span>
          </router-link>
          <button type="button" class="btn btn-sm p-0 fs-20 header-item float-end btn-vertical-sm-hover" id="vertical-hover" @click="initActiveMenu">
            <i class="ri-record-circle-line"></i>
          </button>
        </div>

        <SimpleBar id="scrollbar" class="h-100" ref="scrollbar">
          <Menu></Menu>
        </SimpleBar>
      </div>
      <!-- Left Sidebar End -->
      <!-- Vertical Overlay-->
      <div class="vertical-overlay" id="overlay"></div>
    </div>
    <!-- ============================================================== -->
    <!-- Start Page Content here -->
    <!-- ============================================================== -->

    <div class="main-content">
      <div class="page-content">
        <!-- Start Content-->
        <div class="container-fluid">
          <router-view />

          <Footer />
        </div>
      </div>
    </div>
    <RightBar />
  </div>
</template>